export var valuesConfirmRegisterRequestResultDto = ["UserCreatedAndApproved", "WaitingForApproval"];
/*

*/ 
//# sourceMappingURL=ConfirmRegisterRequestResult.js.map